import { environment } from '../../environments/environment';
export { environment } from '../../environments/environment';

export function getFleetApiUrl(path: string, params?: Object) {
    const fleet = environment.fleet;
    let url = environment.apiHost + fleet + path;
    if (params instanceof Object) {
        url += '?';

        Object.entries(params).forEach(([param, value]) => {
            url += `${encodeURIComponent(param)}=${encodeURIComponent(value)}&`;
        });
    }
    return url;
}